export default __webpack_public_path__ + "static/media/footer_border.0be10a2b.png";